"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 * @author Radek Beran
 */


var CategoryCleaningState =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CategoryCleaningState, _DomainObject_1$Domai);

  /**
   * Constructs internal product category.
   *
   * @param id internal id
   * @param categoryId id of associated product category
   * @param cleaned if competitor prices in category are approved
   * @param hasNewCompetitorPrices if category contains paired internal-competitor product with new price in external competitor
   * @param suspiciousCRPCounts the number of products with suspiciously low or high new competitor reference
   * @param productMessages messages for internal products within data cleaning category
   */
  function CategoryCleaningState(id, categoryId, cleaned, hasNewCompetitorPrices, suspiciousCRPCounts, productMessages) {
    var _this;

    _classCallCheck(this, CategoryCleaningState);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoryCleaningState).call(this));
    _this.id = id;
    _this.categoryId = categoryId;
    _this.cleaned = cleaned;
    _this.hasNewCompetitorPrices = hasNewCompetitorPrices;
    _this.suspiciousCRPCounts = suspiciousCRPCounts;
    _this.productMessages = productMessages;
    return _this;
  }

  return CategoryCleaningState;
}(DomainObject_1.DomainObject);

exports.CategoryCleaningState = CategoryCleaningState;